<template>
  <bm-overlay ref="customOverlay" class="samp" pane="labelPane" @draw="draw">
    <span
      class="map-info-box-2"
      :class="{ 'map-info-yellow-2': active }"
      @click="handleClick">
      {{ text }}
    </span>
    <!-- <div v-text="text" @click="handleClick"></div> -->
  </bm-overlay>
</template>

<script>
  export default {
    props: ["text", "position", "active"],
    watch: {
      position: {
        handler() {
          this.$refs.customOverlay.reload();
        },
        deep: true,
      },
    },
    methods: {
      handleClick() {
        this.$emit("handleClick");
        // global.alert("Well done.");
      },
      draw({ el, BMap, map }) {
        const { lng, lat } = this.position;
        const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
        el.style.left = pixel.x - 160 + "px";
        el.style.top = pixel.y - 120 + "px";
      },
    },
  };
</script>

<style scoped lang="scss">
  // .map-info-box-2 {
  //   min-width: 200px;
  //   overflow: hidden;
  // }
  .samp {
    width: 200px;
    position: absolute;
  }

  .map-info-box-2 {
    position: relative;
    cursor: pointer;
    background-color: #d3e4f4;
    border: 1px solid #d3e4f4;
    padding: 1px 10px;
    white-space: nowrap;
    font: 18px / 36px arial, sans-serif;
    z-index: 999;
    color: #045afc;
    border-radius: 5px;
    height: 40px;
    user-select: none;
  }

  .map-info-box-2:hover {
    background-color: #7ab4f4;
    border: 1px solid #7ab4f4;
    color: #fff;
    z-index: 9999;
  }

  .map-info-box-2:hover:after {
    border-top: 9px solid #7ab4f4;
  }

  .map-info-box-2:after {
    position: absolute;
    background: transparent;
    top: 100%;
    left: calc(50% - 11px);
    width: 25px;
    height: 30px;
    content: "";
    box-sizing: border-box;
    border-top: 9px solid #d3e4f4;
    border-left: 14px solid transparent;
    border-right: 11px solid transparent;
    background-position: -20px bottom;
    background-origin: border-box;
  }

  .map-info-yellow-2 {
    background-color: #7ab4f4;
    border: 1px solid #7ab4f4;
    z-index: 99999;

    color: #fff;
  }

  .map-info-yellow-2:after {
    border-top: 9px solid #7ab4f4;
  }
</style>
